module.exports = __webpack_public_path__ + "static/flute-45d2ec433d6ecf6ad941b56f92aceb2a.webp";